import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
const setStatus = (document) => {
    if (!document.requiresAcknowledgement) {
        return 'not-required';
    }
    switch (document.reply.answer) {
        case 1:
            return 'acknowledged';
        case 0:
            return 'pending';
        default:
            exhaustiveCheck(document.reply.answer);
            return 'not-required';
    }
};
export const parentDocumentForChildProfileTypePatcher = (data) => {
    return {
        __typename: 'ParentDocumentForChildProfile',
        ...data,
        documentId: data.permissionId,
        acknowledgementStatus: setStatus(data),
        documentReplyId: data.reply.permissionReplyId,
    };
};
